import React, { useEffect, useState, createContext, useContext } from 'react';
import firebase from '../config/firebase.config';
import { UserContext } from './UserContext';

export const PeopleContext = createContext();

export const PeopleContextProvider = ({ children }) => {
  const { userUid } = useContext(UserContext);
  const [peopleData, setPeopleData] = useState([]);

  useEffect(() => {
    const downloadPeopleData = firebase
      .firestore()
      .collection('People')
      .onSnapshot((people) => {
        const allPeopleData = [];
        people.forEach((person) => {
          allPeopleData.push({ ...person.data(), id: person.id });
        });
        setPeopleData(allPeopleData);
      }, []);

    return () => {
      downloadPeopleData();
    };
  }, [userUid]);

  function addPerson(doc) {
    firebase.firestore().collection('People').add(doc);
  }

  function deletePerson(id) {
    firebase.firestore().collection('People').doc(id).delete();
  }

  const value = {
    addPerson,
    deletePerson,
    peopleData,
  };
  return (
    <PeopleContext.Provider value={value}>{children}</PeopleContext.Provider>
  );
};

export default PeopleContextProvider;
